module.exports = __webpack_public_path__ + "static/media/icon_rei403609f443f98262233e2f15769ca88c.webp";